// @ts-check
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField, MenuItem, CircularProgress } from '@material-ui/core';

import { getPartners } from '../redux/actions/client-actions';
import { ClientPartnersComponent } from '../components/selected-client-partners';
import { addClientPartnerAction } from '../redux/actions/client-actions';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  maringCancel: {},
  formButtons: {
    marginTop: theme.spacing(4)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  dialog: {
    top: '25%',
    left: 0,
    right: 0,
    margin: '0 auto',
    padding: '0 20px'
  }
}));

function SelectClientThirdPartyLogisticsPartner(props) {
  const classes = useStyles();
  const { error, loading } = useSelector((state) => state.loading);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  let partners_list = [];

  const [selectedOption, setSelectedOption] = useState({});

  const close = () => {
    setIsOpen(false);
  };
  const { partners, client } = props;

  const updateThreePlPartner = (option) => {
    const client_id = client.id;
    partners_list.push(option);

    // @ts-ignore
    dispatch(addClientPartnerAction(client_id, partners_list));
  };

  return (
    <div>
      <TextField
        id="outlined-select-currency"
        select
        label="Choose Partner"
        variant="outlined"
        fullWidth={true}
      >
        {partners.map((option) => (
          <MenuItem key={option.id} value={option.name} onClick={() => setSelectedOption(option)}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
              onClick={() => updateThreePlPartner(selectedOption)}
            >
              Select 3PL partner
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}
      </div>
      <div>
        <ClientPartnersComponent partners={client.partners} client={client} />
      </div>
    </div>
  );
}

export function SelectBranchThirdPartyPartnerComponent() {
  const dispatch = useDispatch();
  const { partners } = useSelector((state) => state.partners);
  const { client } = useSelector((state) => state.client);

  useEffect(() => {
    dispatch(getPartners());
  }, [dispatch]);

  return <SelectClientThirdPartyLogisticsPartner partners={partners} client={client} />;
}
